import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';
import { StoresServerSideField } from 'src/components/common/stores/stores-serverside';
import { UsersServerSideField } from 'src/components/common/users/users-serverside';
import { UserMergeRequestStatus } from 'src/graphql/generated/graphql';

type GetFilterConfigProps = {
  t: TFunction;
  size: number;
};

export const getFilterConfig = ({ t, size }: GetFilterConfigProps) => [
  {
    id: 'status',
    size,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('columns.status'),
        name: 'status',
        label: t('columns.status'),
      },
      options: [
        {
          value: UserMergeRequestStatus.Approved,
          name: t('columns.status-approved'),
        },
        {
          value: UserMergeRequestStatus.Pending,
          name: t('columns.status-pending'),
        },
        {
          value: UserMergeRequestStatus.Rejected,
          name: t('columns.status-rejected'),
        },
      ],
    },
  },
  {
    id: 'previousStoreNumbers',
    size,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <StoresServerSideField {...props}></StoresServerSideField>
    ),
    props: {
      inputProps: {
        placeholder: t('columns.previous-store-numbers'),
        name: 'previousStoreNumbers',
        label: t('columns.previous-store-numbers'),
      },
    },
  },
  {
    id: 'userId',
    size,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <UsersServerSideField {...props}></UsersServerSideField>
    ),
    props: {
      inputProps: {
        placeholder: t('columns.user'),
        name: 'userId',
        label: t('columns.user'),
      },
    },
  },
  {
    id: 'createdByUserId',
    size,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <UsersServerSideField {...props}></UsersServerSideField>
    ),
    props: {
      inputProps: {
        placeholder: t('columns.created-by'),
        name: 'createdByUserId',
        label: t('columns.created-by'),
      },
    },
  },
];
